import React, {useState} from 'react'
import './ctas.scss'
import { ctas, menu } from './../../constants'
import walmartLogo from './../../assets/walmart_logo.png'


const CTAs = ({onClick, findUrl, buyUrl}) => {
    const {FIND_IT, BUY_IT} = ctas

    return (
        <div className="ctas">
            <a href={menu.LOCATOR.URL} target="_blank"><button>{FIND_IT}</button></a>
            {/* <button onClick={()=> onClick(true)}>{BUY_IT}</button> */}
        </div>
    )
}

export default CTAs
